import React from 'react';

import i18n from '../../../i18n';
import styles from './styles.module.scss';

const months = i18n.t('datePicker.months');

const topBarTexts = {
  year: i18n.t('datePicker.chooseYear'),
  month: i18n.t('datePicker.chooseMonth'),
  date: i18n.t('datePicker.chooseDay'),
};

export default function TopBar({ status, date }) {
  const heading = topBarTexts[status];

  return (
    <div className={styles.topBarContainer}>
      <div className={`${styles.dateContainer} ${styles[status]}`}>
        {status === 'date' && (
          <div className={styles.datePart}>{date.getDate()}</div>
        )}
        {status === 'date' && (
          <div className={styles.datePart}>{months[date.getMonth()]}</div>
        )}
        {status !== 'year' && (
          <div className={styles.datePart}>{date.getYear() + 1900}</div>
        )}
      </div>
      <div className={styles.heading}>{heading}</div>
    </div>
  );
}
